<template>
	<div>
		<div class="device-type-info app-region blank-t-v blank-l-h blank-r-h">

			<a-row type="flex" class="font-bold bb">
				<a-col>
					<p class="blank-l-h">基础信息</p>
				</a-col>
			</a-row>

			<a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal blank-t-v blank-b-v">
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p prop="name">类型名称</p>
						</a-col>
						<a-col>
							<a-input placeholder="请输入设备类型名称" v-model="table.name"></a-input>
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p prop="type_code">类型编码</p>
						</a-col>
						<a-col>
							<a-input placeholder="请输入设备类型编码" v-model="table.type_code"></a-input>
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p prop="type_code">类型备注</p>
						</a-col>
						<a-col>
							<a-input placeholder="请输入类型备注" v-model="table.remark"></a-input>
						</a-col>
					</a-row>
				</a-col>
			</a-row>
		</div>

		<!-- 维保项目 -->
		<div class="device-type-info app-region blank-t-v blank-l-h blank-r-h">
			<a-row type="flex" class="font-bold bb">
				<a-col>
					<p prop="maintain" class="blank-l-h">维保设置</p>
				</a-col>
			</a-row>

			<a-row class="mg-normal" type="flex" justify="space-between">
				<a-col>
					<a-space>
						<a-button type="primary" @click="newMainDevice()">添加项目</a-button>
					</a-space>
				</a-col>
				<a-col :span="8">
					<a-input-search  v-model="mainName" placeholder="请输入维保项目" @search="searchMainTable" />
				</a-col>
			</a-row>

			<a-table v-model="table.maintain" class="mg-normal" :loading="table.loading" :columns="table.columns"
				:rowKey="(record,index)=>{return index}" :data-source="table.data" :pagination="table.page"
				@change="handlePageChange">
				<template slot="action" slot-scope="text, data,index">
					<a-space>
						<a-button type="link" @click="editMainDevice(data,index)">编辑</a-button>
						<a-button type="link" @click="delMainDevice(data,index)">删除</a-button>
					</a-space>
				</template>
			</a-table>
		</div>

		<!-- 巡检项目 -->
		<div class="device-type-info app-region blank-t-v blank-l-h blank-r-h">
			<a-row type="flex" class=" font-bold bb">
				<a-col>
					<p prop="inspect" class="blank-l-h">巡检设置</p>
				</a-col>
			</a-row>
			<a-row class="mg-normal" type="flex" justify="space-between">
				<a-col>
					<a-space>
						<a-button type="primary" @click="newInspDevice()">添加项目</a-button>
					</a-space>
				</a-col>
				<a-col :span="8">
					<a-input-search  v-model="inspName" placeholder="请输入巡检项目" @search="searchInspTable" />
				</a-col>
			</a-row>

			<a-table v-model="table.inspect" class="mg-normal" :loading="table.loading" :columns="table.columnsTwo"
				:data-source="table.dataTwo" :rowKey="(record,index)=>{return index}" :pagination="table.pageTwo"
				@change="handlePageTwoChange">
				<template slot="action" slot-scope="text, dataTwo,indexTwo">
					<a-space>
						<a-button type="link" @click="editInspDevice(dataTwo,indexTwo)">编辑</a-button>
						<a-button type="link" @click="delInspDevice(dataTwo,indexTwo)">删除</a-button>
					</a-space>
				</template>
			</a-table>
		</div>

		<!-- 新增维保项目 -->
		<a-modal v-model="addDeviceModal.show" :title="addDeviceModal.title" :confirm-loading="addDeviceModal.loading"
			@ok="confirmAddDeviceModal" destroy-on-close centered>
			<a-form-model ref="form" :model="form" layout="vertical"  class="blank-b-v">
				<a-form-model-item label="维保等级" >
					<a-select class="app-block" v-model="form.levelForm" placeholder="请选择维保等级">
						<a-select-option :value='1'>日常维保</a-select-option>
						<a-select-option :value='2'>一级维保</a-select-option>
						<a-select-option :value='3'>二级维保</a-select-option>
						<a-select-option :value="4">三级维保</a-select-option>
						<a-select-option :value="5">四级维保</a-select-option>
					</a-select>
				</a-form-model-item>
			</a-form-model>
			<a-form-model ref="form" :model="form" layout="vertical"  class="blank-b-v">
				<a-form-model-item label="维保项目" prop="maintain_item">
					<a-input v-model="form.maintain_item" placeholder="请输入维保项目"></a-input>
				</a-form-model-item>
			</a-form-model>
			<a-form-model ref="form" :model="form" layout="vertical"  class="blank-b-v">
				<a-form-model-item label="维保标准" prop="maintain_standard">
					<a-textarea v-model="form.maintain_standard" placeholder="请输入维保标准"></a-textarea>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<!-- 编辑维保项目 -->
		<a-modal v-model="editDeviceModal.show" :title="editDeviceModal.title" :confirm-loading="editDeviceModal.loading"
		 @ok="confirmEditDeviceModal" destroy-on-close centered>
			<a-form-model ref="form" :model="form" layout="vertical" class="blank-b-v">
				<a-form-model-item label="维保等级" >
					<a-select class="app-block" v-model="form.levelForm" placeholder="请选择维保等级">
						<a-select-option :value='1'>日常维保</a-select-option>
						<a-select-option :value='2'>一级维保</a-select-option>
						<a-select-option :value='3'>二级维保</a-select-option>
						<a-select-option :value="4">三级维保</a-select-option>
						<a-select-option :value="5">四级维保</a-select-option>
					</a-select>
				</a-form-model-item>
			</a-form-model>
			<a-form-model ref="form" :model="form" layout="vertical" class="blank-b-v">
				<a-form-model-item label="维保项目" prop="maintain_item">
					<a-input v-model="form.maintain_item" placeholder="请输入维保项目"></a-input>
				</a-form-model-item>
			</a-form-model>
			<a-form-model ref="form" :model="form" layout="vertical" class="blank-b-v">
				<a-form-model-item label="维保标准" prop="maintain_standard">
					<a-textarea v-model="form.maintain_standard" placeholder="请输入维保标准"></a-textarea>
				</a-form-model-item>
			</a-form-model>
		</a-modal>



		<!-- 新增巡检项目 -->
		<a-modal v-model="addTwoDeviceModal.show" :title="addTwoDeviceModal.title" :confirm-loading="addTwoDeviceModal.loading"
		 @ok="confirmTwoAddDeviceModal()" destroy-on-close centered>
			<a-form-model ref="formTwo" :model="formTwo" layout="vertical" class="blank-b-v">
				<a-form-model-item label="巡检项目" prop="inspect_item">
					<a-input v-model="formTwo.inspect_item" placeholder="请输入巡检项目名称"></a-input>
				</a-form-model-item>
			</a-form-model>
			<a-form-model ref="formTwo" :model="formTwo" layout="vertical"  class="blank-b-v">
				<a-form-model-item label="巡检标准" prop="inspect_standard">
					<a-textarea v-model="formTwo.inspect_standard" placeholder="请输入巡检要求"></a-textarea>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<!-- 编辑巡检项目 -->
		<a-modal v-model="editTwoDeviceModal.show" :title="editTwoDeviceModal.title" :confirm-loading="editTwoDeviceModal.loading"
		@ok="confirmTwoEditDeviceModal()" destroy-on-close centered>
			<a-form-model ref="formTwo" :model="formTwo" layout="vertical"  class="blank-b-v">
				<a-form-model-item label="巡检项目" prop="inspect_item">
					<a-input v-model="formTwo.inspect_item" placeholder="请输入巡检项目名称"></a-input>
				</a-form-model-item>
			</a-form-model>
			<a-form-model ref="formTwo" :model="formTwo" layout="vertical"  class="blank-b-v">
				<a-form-model-item label="巡检标准" prop="inspect_standard">
					<a-textarea v-model="formTwo.inspect_standard" placeholder="请输入巡检要求"></a-textarea>
				</a-form-model-item>
			</a-form-model>
		</a-modal>



		<footer class="app-footer blank-t-v blank-b-v ">
			<a-row type="flex" justify="end">
				<a-col>
					<a-space>
						<a-button @click="cancel">取消</a-button>
						<a-button type="primary" @click="submit">提交</a-button>
					</a-space>
				</a-col>
			</a-row>
		</footer>
		<div class="bottombox"></div>
	</div>


</template>

<script>
	import DeviceType from '@/io/device_type.js'
	import {
		mainLevel
	} from '@/io/dict.js';

	export default {
		name: 'DeviceTypeInfo',
		data() {
			let self = this;
			return {
				// 传来的id
				id: this.$route.params.id,
				mainName: '',
				mainArr:'',
				inspName:'',
				inspArr:'',
				levels:'',
				

				mainLevel,
				table: {
					name: null,
					type_code: null,
					remark: null,
					maintain: [],
					inspect: [],

					loading: false,

					

					page: {
						total: 0,
						current: 1,
						pageSize: 10,
						showQuickJumper: true,
						showSizeChanger: true,
						showTotal() {
							return `共${self.table.page.total}条`;
						}
					},
					pageTwo: {
						total: 0,
						current: 1,
						pageSize: 10,
						showQuickJumper: true,
						showSizeChanger: true,
						showTotal() {
							return `共${self.table.pageTwo.total}条`;
						}
					},
					data: [],

					columns: [{
							title: '维保等级',
							dataIndex: 'level'
						},
						{
							title: '维保项目',
							dataIndex: 'maintain_item'
						},
						{
							title: '维保标准',
							dataIndex: 'maintain_standard'
						},

						{
							title: '操作',
							scopedSlots: {
								customRender: 'action'
							},
						}
					],
					dataTwo: [],
					columnsTwo: [{
							title: '巡检项目',
							dataIndex: 'inspect_item'
						},
						{
							title: '巡检标准',
							dataIndex: 'inspect_standard'
						},
						{
							title: '操作',
							scopedSlots: {
								customRender: 'action'
							},
						}
					]
				},

				// 这是弹框内的form
				form: {
					levelForm: [],
					maintain_item: null,
					maintain_standard: null
				},
				formTwo: {
					inspect_item: null,
					inspect_standard: null
				},
				
				// 添加维保项目
				addDeviceModal: {
					title: '添加维保项目',
					show: false,
					loading: false
				},
				editDeviceModal: {
					id: null,
					status: null,
					title: '编辑维保项目',
					show: false,
					loading: false
				},
				// 添加巡检项目
				addTwoDeviceModal: {
					title: '添加巡检项目',
					show: false,
					loading: false
				},
				editTwoDeviceModal: {
					id: null,
					status: null,
					title: '编辑巡检项目',
					show: false,
					loading: false
				},
			}
		},


		mounted() {
			if (this.$route.params.id) {
				this.initPage()
			}
		},
		activated() {
			this.initData()
		},

		methods: {
			// 获取数据
			
			initPage() {
				DeviceType.info(this.id).then(res => {
					
					this.table.name = res.name;
					this.table.type_code = res.type_code
					this.table.remark = res.remark
					
					// console.log('res.maintain',res.maintain)
					this.table.data = res.maintain
					this.mainArr = this.table.data
					
					this.table.dataTwo = res.inspect
					this.inspArr = this.table.dataTwo
					
					this.table.page.total = res.maintain.length
					this.table.pageTwo.total = res.inspect.length
				}).catch(err => {})

			},

			// 添加维保项目
			newMainDevice() {
				this.form.levelForm = null;
				this.form.maintain_item = null;
				this.form.maintain_standard = null;
				this.addDeviceModal.show = true;
			},
			// 点击确定，将form内的数据传入表格内
			confirmAddDeviceModal() {
					this.addDeviceModal.loading = true;
					console.log('00001222',this.form.levelForm)
					if(this.form.levelForm == 1){
						this.levels = '日常维保'
					}
					if(this.form.levelForm == 2){
						this.levels  = '一级维保'
					}
					if(this.form.levelForm == 3){
						this.levels  = '二级维保'
					}
					if(this.form.levelForm == 4){
						this.levels = '三级维保'
					}
					if(this.form.levelForm == 5){
						this.levels  = '四级维保'
					}
					// console.log('00000000',this.levels)
					this.table.data.push({
						// form 传入 表格 
						level: this.levels ,
						maintain_item: this.form.maintain_item,
						maintain_standard: this.form.maintain_standard,
					})
					console.log('00000',this.table.data)
					
					this.addDeviceModal.show = false;
					this.addDeviceModal.loading = false;
					this.table.page.total = this.table.data.length
					this.mainArr = this.table.data
					
			},
			// 修改数据
			editMainDevice(data, id) {
					this.form.levelForm = data.level,
					this.form.maintain_item = data.maintain_item,
					this.form.maintain_standard = data.maintain_standard,
					this.editDeviceModal.id = id;
				    this.editDeviceModal.show = true;
			},
			// 修改确定按钮
			confirmEditDeviceModal() {
				
				if(this.form.levelForm == 1){
					this.levels = '日常维保'
				}
				if(this.form.levelForm == 2){
					this.levels  = '一级维保'
				}
				if(this.form.levelForm == 3){
					this.levels  = '二级维保'
				}
				if(this.form.levelForm == 4){
					this.levels = '三级维保'
				}
				if(this.form.levelForm == 5){
					this.levels  = '四级维保'
				}
				this.table.data[this.editDeviceModal.id].level  = this.levels
				// console.log('this.table.data[this.editDeviceModal.id].level 00000',this.table.data[this.editDeviceModal.id].level )
				this.table.data[this.editDeviceModal.id].maintain_item = this.form.maintain_item
				this.table.data[this.editDeviceModal.id].maintain_standard = this.form.maintain_standard
				this.editDeviceModal.loading = true;
				this.editDeviceModal.show = false;
				this.editDeviceModal.loading = false;
			},
			delMainDevice(data, id) {
				this.table.data.splice(id, 1)
				this.table.page.total = this.table.data.length
				this.mainArr = this.table.data
			},

			// 添加巡检项目
			newInspDevice() {
				this.formTwo.inspect_item = null;
				this.formTwo.inspect_standard = null;
				this.addTwoDeviceModal.show = true;
			},
			confirmTwoAddDeviceModal() {
					this.addTwoDeviceModal.loading = true;
					this.table.dataTwo.push({
						inspect_item: this.formTwo.inspect_item,
						inspect_standard: this.formTwo.inspect_standard,
					})
					this.addTwoDeviceModal.show = false;
					this.addTwoDeviceModal.loading = false;
					this.table.pageTwo.total = this.table.dataTwo.length
					this.inspArr = this.table.dataTwo
			},
			// 修改数据
			editInspDevice(dataTwo, id) {
				this.formTwo.inspect_item = dataTwo.inspect_item,
				this.formTwo.inspect_standard = dataTwo.inspect_standard,
				this.editTwoDeviceModal.id = id;
				this.editTwoDeviceModal.show = true;
			},
			confirmTwoEditDeviceModal() {
				this.table.dataTwo[this.editTwoDeviceModal.id].inspect_item = this.formTwo.inspect_item
				this.table.dataTwo[this.editTwoDeviceModal.id].inspect_standard = this.formTwo.inspect_standard
				this.editTwoDeviceModal.loading = true;
				this.editTwoDeviceModal.show = false;
				this.editTwoDeviceModal.loading = false;

			},
			delInspDevice(dataTwo, id) {
				this.table.dataTwo.splice(id, 1)
				this.table.pageTwo.total = this.table.dataTwo.length
				this.inspArr = this.table.dataTwo
			},

			searchMainTable() {
				// mainName绑定的值
				if(this.mainName){
					var mainMany = []
					for (let i = 0;i<this.table.data.length;i++) {
						if( this.table.data[i].maintain_item.indexOf(this.mainName)>-1){
							mainMany.push(this.table.data[i])
						}
					}
					this.table.data = mainMany
				}else{
					this.table.data = this.mainArr
				}
				
			},
			searchInspTable() {
				if(this.inspName){
					var inspMany = []
					for(let i = 0;i<this.table.dataTwo.length;i++){
						if(this.table.dataTwo[i].inspect_item.indexOf(this.inspName)>-1){
							inspMany.push(this.table.dataTwo[i])
						}
					}
					this.table.dataTwo = inspMany
				}else{
					this.table.dataTwo =  this.inspArr
				}
				console.log('dataTwo',this.table.dataTwo)
			},
			//分页
			handlePageChange(page) {
				this.table.page.current = page.current;
				this.table.page.pageSize = page.pageSize;
				this.initData();
			},
			handlePageTwoChange(pageTwo) {
				this.table.pageTwo.current = pageTwo.current;
				this.table.pageTwo.pageSize = pageTwo.pageSize;
				this.initData();
			},

			initData() {
				this.table.loading = true;
				DeviceType.listPage(
					this.table.name,
					this.table.type_code,
					this.table.remark,
					this.table.maintain,
					this.table.inspect,
					this.table.page.current,
					this.table.page.pageSize,
					this.table.pageTwo.current,
					this.table.pageTwo.pageSize,
				).then(res => {

					this.table.data = res.data.map(val => {
						return val;
					});
				}).catch(err => {}).finally(() => {
					// this.table.loading = false;
				});
			},
			submit() {
				
			
				
				if (this.id) {
				
					for(let i=0;i<this.table.data.length;i++){
						if(this.table.data[i].level=='日常维保'){
							this.table.data[i].level = 1
						}else if(this.table.data[i].level=='一级维保'){
							this.table.data[i].level = 2
						}else if(this.table.data[i].level=='二级维保'){
							this.table.data[i].level = 3
						}else if(this.table.data[i].level=='三级维保'){
							this.table.data[i].level = 4
						}else if(this.table.data[i].level=='四级维保'){
							this.table.data[i].level = 5
						}
					}
					// console.log('988888',this.table.data)
					
					DeviceType.edit(
					
						this.id,
						this.table.name,
						this.table.type_code,
						this.table.remark,
						this.table.data,
						this.table.dataTwo,
					).then((res) => {
						this.$afterFormSubmit('编辑成功', () => {
							this.cancel();
						});
					}).catch((err) => {});
				} else {
					for(let i=0;i<this.table.data.length;i++){
						if(this.table.data[i].level=='日常维保'){
							this.table.data[i].level = 1
						}else if(this.table.data[i].level=='一级维保'){
							this.table.data[i].level = 2
						}else if(this.table.data[i].level=='二级维保'){
							this.table.data[i].level = 3
						}else if(this.table.data[i].level=='三级维保'){
							this.table.data[i].level = 4
						}else if(this.table.data[i].level=='四级维保'){
							this.table.data[i].level = 5
						}
					}
					console.log('988888',this.table.data)
					DeviceType.add(
						this.table.name,
						this.table.type_code,
						this.table.remark,
						this.table.data,
						this.table.dataTwo,
					).then((res) => {
						this.$afterFormSubmit('编辑成功', () => {
							this.cancel();
						});
					}).catch((err) => {});
				}
			},
			cancel() {
				this.$router.push({
					name: 'DeviceType'
				})
			},
		},

	}
</script>

<style lang="less" scoped>


</style>
